import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../Stores/useAuthStore';
import { getRedirectHomePath } from '../../Routing/navigationUtils';
import { Loader } from '../../Components/Loader/Loader';


export const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();
  const [loading, setLoading] = useState(false); 

  const handleGoHome = () => {
    setLoading(true);
    const redirectPath = getRedirectHomePath(isAuthenticated, user);
    navigate(redirectPath);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh' }}>
      <h3>{t('page_not_found.title')}</h3>
      <button
        onClick={handleGoHome}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          cursor: 'pointer',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          fontSize: '16px',
          fontWeight: 'bold',
          transition: 'background-color 0.3s ease',
        }}
        disabled={loading}
      >
        {loading ? <Loader isLoading={loading} /> : t('page_not_found.button')}
      </button>
    </div>
  );
};